import { OPFSAdapter } from '../../file-system-adapter';
import { FilesystemPlugin } from '../filesystem-plugin';
/**
 * Memory Plugin - uses OPFS (Origin Private File System) for browser storage
 */
export class MemoryPlugin extends FilesystemPlugin {
    constructor() {
        super(new OPFSAdapter());
    }
    getId() {
        return 'memory';
    }
    getName() {
        return 'Memory';
    }
    getIcon() {
        return '<span class="material-symbols-outlined">memory</span>';
    }
    getDefaultPath() {
        return '/user';
    }
}
